export default {
  styleOverrides: {
    root: {
      fontFamily: 'Source Han Sans CN, Arial, sans-serif',
    },
    subtitle1: {
      fontSize: 14,
    },
    gutterBottom: {
      marginBottom: 8,
    },
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 12,
    },
  },
};
